import Enum from "../../../enum";
import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../../constants";

export const participantSchema = {
    "documentParticipant": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "memberId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "memberExternalStateId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_STATE_ID,
            value: "",
        },
        "memberExternalStateName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_STATE_NAME,
            value: "",
        },
        "memberExternalUpdatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "memberNumber": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NUMBER,
            value: "",
        },
        "memberName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "memberEmail": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EMAIL,
            value: "",
        },
        "memberPhone": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.PHONE,
            value: "",
        },
        "memberCellPhone": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.CELL_PHONE,
            value: "",
        },
        "memberAddress": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ADDRESS,
            value: "",
        },
        "memberBirthDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "memberJoinDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "memberQuitDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "memberProfileUrl": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.URL,
            value: "",
        },
        "memberRole": {
            type: DATA_TYPE.ENUM,
            enum: "MemberRole",
            value: null,
        },
        "memberState": {
            type: DATA_TYPE.ENUM,
            enum: "MemberState",
            value: null,
        },
        "externalStateId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_STATE_ID,
            value: "",
        },
        "externalStateName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_STATE_NAME,
            value: "",
        },
        "externalUpdatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "number": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NUMBER,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "email": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EMAIL,
            value: "",
        },
        "phone": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.PHONE,
            value: "",
        },
        "cellPhone": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.CELL_PHONE,
            value: "",
        },
        "address": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ADDRESS,
            value: "",
        },
        "birthDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "joinDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "quitDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "profileUrl": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.URL,
            value: "",
        },
        "role": {
            type: DATA_TYPE.ENUM,
            enum: "MemberRole",
            value: Enum.BE_MEMBER_ROLE.MEMBER,
        },
        "state": {
            type: DATA_TYPE.ENUM,
            enum: "MemberState",
            value: Enum.BE_MEMBER_STATE.ACTIVE,
        },
        "departmentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "departmentExternalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "departmentCode": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.CODE,
            value: "",
        },
        "departmentName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "departmentDescription": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "departmentOrder": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "departmentStartDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "departmentEndDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "departmentParentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "departmentMemberRole": {
            type: DATA_TYPE.ENUM,
            enum: "DepartmentMemberRole",
            value: Enum.BE_DEPARTMENT_MEMBER_ROLE.DEPARTMENT_MEMBER,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "documentLabel": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "referenceType": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentLabelReferenceType",
            value: null,
        },
        "referenceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "labelId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "externalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "code": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.CODE,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "color": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.COLOR,
            value: "",
        },
        "order": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "type": {
            type: DATA_TYPE.ENUM,
            enum: "LabelType",
            value: null,
        },
        "remark": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        // 검색용 가상 필드 - labelType=DOCUMENT_TYPE인 라벨 검색
        "DOCUMENT_TYPE": {
            type: DATA_TYPE.ENUM,
            enum: "LabelDocumentType",
            value: null,
        },
        // 검색용 가상 필드 - labelType=APPROVAL_REQUEST_REASON인 라벨 검색
        "APPROVAL_REQUEST_REASON": {
            type: DATA_TYPE.ENUM,
            enum: "LabelApprovalRequestReason",
            value: null,
        },
    },

    "documentDepartment": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "referenceType": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentDepartmentReferenceType",
            value: null,
        },
        "referenceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "departmentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "externalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "code": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.CODE,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "role": {
            type: DATA_TYPE.ENUM,
            enum: "DepartmentMemberRole",
            value: null,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "documentRequester": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "documentRevoker": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "type": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentRevokerType",
            value: null,
        },
        "message": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
        "documentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentParticipantActorType": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentParticipantActorType",
            value: Enum.BE_DOCUMENT_PARTICIPANT_ACTOR_TYPE.NONE,
        },
        "documentParticipantActorId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "documentApprover": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "order": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "status": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentApproverStatus",
            value: Enum.BE_DOCUMENT_APPROVER_STATUS.NONE,
        },
        "documentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentParticipantActorType": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentParticipantActorType",
            value: Enum.BE_DOCUMENT_PARTICIPANT_ACTOR_TYPE.NONE,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "documentSealApprover": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "order": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "status": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentSealApproverStatus",
            value: null,
        },
        "documentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentSealId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentParticipantActorType": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentParticipantActorType",
            value: Enum.BE_DOCUMENT_PARTICIPANT_ACTOR_TYPE.NONE,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "documentSealManager": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "status": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentSealManagerStatus",
            value: null,
        },
        "documentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentSealId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentParticipantActorType": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentParticipantActorType",
            value: Enum.BE_DOCUMENT_PARTICIPANT_ACTOR_TYPE.NONE,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
    }
} as const;
